import clsx from 'clsx';
import { HandleSearchTermArgs, PageData, Result } from './types';
import React, { CSSProperties } from 'react';
import {
  DLKnowledgehubView,
  DLSearchResultsClick,
} from '@/js/general/data-layer';


export function SearchResult({
  typeName,
  name,
  teaser,
  url,
}: Readonly<Result>) {
  return (
    <a
      href={url}
      className="search-result"
      onClick={() =>
        DLSearchResultsClick({ category: typeName, click_text: name })
      }
    >
      {typeName ? <div className="search-result__tag">{typeName}</div> : null}
      <h4 className="search-result__title">{name}</h4>
      {teaser ? <p className="search-result__description">{teaser}</p> : null}
    </a>
  );
}

export function CardResult({
  typeName,
  name,
  publishedDate,
  url,
  imageUrl,
  isFeatured,
  hasVideo,
}: Readonly<Result & { isFeatured?: boolean }>) {
  return (
    <a
      href={url}
      className={clsx('teaser-card', {
        'no-image': !imageUrl,
        featured: isFeatured,
        'has-video': hasVideo,
      })}
      onClick={() => DLKnowledgehubView({ knowledgehub_type: typeName })}
    >
      {imageUrl ? (
        <img
          className="teaser-card__image"
          src={imageUrl}
          alt=""
          width="414"
          height="220"
        />
      ) : null}
      <div className="teaser-card__content">
        <h4 className="teaser-card__title">{name}</h4>
        <div className="teaser-card__info">
          {typeName ? (
            <div className="teaser-card__type">{typeName}</div>
          ) : null}
          {publishedDate ? (
            <div className="teaser-card__date">{publishedDate}</div>
          ) : null}
        </div>
      </div>
    </a>
  );
}

export function PersonResult({
  name,
  url,
  imageUrl,
  countryName,
  positionName,
}: Readonly<Result>) {
  return (
    <a href={url} className="people-gallery__item">
      <div className="people-gallery__item-image-wrapper">
        <img
          src={imageUrl}
          className="people-gallery__item-image"
          width={325}
          height={430}
          alt=""
        />
        <img
          src={imageUrl}
          className="people-gallery__item-image people-gallery__item-image--fixed"
          width={325}
          height={430}
          alt=""
        />
        <img
          src={imageUrl}
          className="people-gallery__item-image people-gallery__item-image--fixed"
          width={325}
          height={430}
          alt=""
        />
      </div>

      <div className="people-gallery__item-content">
        <div className="people-gallery__item-title">{name}</div>
        <div className="people-gallery__item-subtitle">{positionName}</div>
        <div className="people-gallery__item-location">
          <i className="icon-pin"></i>
          <span>{countryName}</span>
        </div>
      </div>
    </a>
  );
}

export function EventResult({
  name,
  url,
  imageUrl,
  teaser,
  eventDateString,
  eventTimeString,
  eventTypeString,
}: Readonly<Result>) {
  return (
    <a className="event-result" href={url}>
      <img
        alt=""
        className="event-result__image"
        height="218"
        src={imageUrl}
        width="330"
      />
      <div className="event-result__content">
        <h4 className="event-result__title">{name}</h4>
        <p className="event-result__copy">{teaser}</p>
      </div>
      <div className="event-result__info">
        <span className="location">
          <i className="icon-location"></i>
          <span>{eventTypeString}</span>
        </span>
        <span>{eventDateString}</span>
        <span>{eventTimeString}</span>
      </div>
    </a>
  );
}

export function Skeleton({ amount = 6 }: { amount?: number }) {
  return [...Array(amount)].map((_, i) => (
    <div
      className="search-result-skeleton"
      key={crypto.randomUUID()}
      style={{ '--i': i } as CSSProperties}
    />
  ));
}

export function PopularSearches({
  searchTerms,
  onClick,
  title,
}: Readonly<{
  searchTerms: PageData['searchTerms'];
  onClick: HandleSearchTermArgs;
  title: string;
}>) {
  return (
    <div className="search-popular">
      <h4 className="search-popular__title">{title}</h4>
      <ul className="search-popular__list">
        {searchTerms.map(term => (
          <li key={`search-term-${term}`}>
            <button
              type="button"
              onClick={e => onClick(e, term)}
              onKeyDown={e => onClick(e, term)}
            >
              {term}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
